import { ColumnState } from "ag-grid-community";
import { create } from "zustand";
import { formatDate } from "src/utils/string/stringUtil";
import { PDA1020_R01Dto, PDA1020_R01Filter } from "./PDA1020_R01Dto";

export interface Store_PDA1020_R01 {
  PDA1020_R01Filter: PDA1020_R01Filter;
  PDA1020_R01List: PDA1020_R01Dto[];
  isLoading: boolean;
  columnState: ColumnState[] | null;
  scrollTop: number | null;

  setPDA1020_R01Filter: (filter: Partial<PDA1020_R01Filter>) => void;
  setPDA1020_R01List: (list: PDA1020_R01Dto[]) => void;
  setIsLoading: (isLoading: boolean) => void;
  setColumnState: (columnState: ColumnState[] | null) => void;
  setScrollTop: (scrollTop: number | null) => void;
  initData: () => void;
}

const createDefaultPDA1020_R01Filter = (): PDA1020_R01Filter => {
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

  return {
    compCd: "",
    startDate: formatDate(firstDay),
    endDate: formatDate(today),
  };
};

export const usePDA1020_R01Store = create<Store_PDA1020_R01>((set) => ({
  PDA1020_R01Filter: createDefaultPDA1020_R01Filter(),
  PDA1020_R01List: [],
  isLoading: false,
  columnState: null,
  scrollTop: null,

  setPDA1020_R01Filter: (filter) =>
    set((state) => ({
      PDA1020_R01Filter: {
        ...state.PDA1020_R01Filter,
        ...filter,
      },
    })),
  setPDA1020_R01List: (list) => set({ PDA1020_R01List: list }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setColumnState: (columnState) => set({ columnState }),
  setScrollTop: (scrollTop) => set({ scrollTop }),
  initData: () =>
    set({
      PDA1020_R01Filter: createDefaultPDA1020_R01Filter(),
      PDA1020_R01List: [],
      isLoading: false,
      columnState: null,
      scrollTop: null,
    }),
}));

export default usePDA1020_R01Store;
